<template>
    <div class="">
        <div class="container">
            <!-- <Breadcrumb class="my-3"/> -->
            <CommonBreadcrumb class="my-3"/>
        </div>
        <section class="banner_block">
            <picture>
                <source media="(min-width: 768px)" width="1920" height="662" srcset="~/assets/landing/wedding/banner.webp">
                <source media="(min-width: 768px)" width="1920" height="662" srcset="~/assets/landing/wedding/banner.jpg">

                <source media="(max-width: 767px)" width="944" height="500" srcset="~/assets/landing/wedding/banner_mobile.webp">
                <source media="(max-width: 767px)" width="944" height="500" srcset="~/assets/landing/wedding/banner_mobile.jpg">
                <!-- <source media="(max-width: 767px)" width="944" height="500"  srcset="/landing/wedding/banner_mobile.webp"> -->

                <img alt="Celebrate commitment with emblems of love!" width="1920" height="662" src="~/assets/landing/wedding/banner.jpg">
            </picture>
            <div class="banner_upper">
                <h1 class="mb-0 font-active">Wedding Rings </h1>
                <p class="mb-0" v-if="$country.is_india">Because Your Special Day Deserves Perfection!</p>
                <p class="mb-0" v-else>Celebrate commitment with emblems of love!</p>
                <NuxtLink class="anker radious_four" :to="localePath({ name:'shop-womens-wedding-rings' })">Shop wedding Rings</NuxtLink>
            </div>
        </section>

        <div class="container">
            <div class="extra_text">
                <p class="mb-0">
                    Say “I Do and Always Will” with elegantly crafted wedding and anniversary rings symbolising true love. Choose from an assortment of simple gold and platinum bands or unique eternity rings to celebrate your landmark moment.
                </p>
                
            </div>
        </div>
        <div class="container-lg">
            <LandingAnniversoryBands />
        </div>
        <div class="container-fluid container_fluid">
            <LandingCyorBanner :page="'wedding'" />
        </div>        
        <div class="container-lg">
            <LandingPopularJewelry />
        </div>
        <div class="container-lg my-5">
            <div class="row modern_block align-items-center">
                <div class="col-12 col-lg-6">
                    <h2 class="font-active">Wedding Creations For <br> The Modern Bride</h2>
                    <p>
                        Celebrate your wedding day with eco-friendly and sustainable 
                        <NuxtLink :to="localePath({ name:'shop-all' })"> lab-grown diamond {{ $t('jewelry') }} </NuxtLink> 
                        specially curated for the modern-day bride. Our wedding {{ $t('jewelry') }} collection includes a diverse 
                        assortment of styles, from diamond wedding rings to fine {{ $t('jewelry') }} pieces like stud earrings, 
                        tennis bracelets, journey necklaces, and solitaire pendants.
                        <br><br>
                        Our competitively priced diamond {{ $t('jewelry') }} will give you your perfect dream look while ensuring 
                        you do not spend an extravagant amount on bridal {{ $t('jewelry') }} within your wedding day budget.  
                        <br><br>
                        We offer a <NuxtLink :to="localePath('/appointment')"> free virtual appointment </NuxtLink> with our 
                        in-house team of certified gemologists and {{ $t('jewelry') }} designers for all the brides-to-be to help 
                        them design the perfect wedding day look.
                        <br><br>
                        Go ahead and browse through our wedding bridal {{ $t('jewelry') }}, find the perfect match, and revel in the 
                        beauty of your wedding day attire!
                    </p>
                </div>
                <div class="col-12 col-lg-6">
                    <picture v-if="$country.is_india">
                        <source media="(min-width: 768px)" width="885" height="885" srcset="~/assets/landing/wedding/india/modern.webp">
                        <source media="(min-width: 768px)" width="885" height="885" srcset="~/assets/landing/wedding/india/modern.jpg">
                        <source media="(max-width: 992px)" width="943" height="726" srcset="~/assets/landing/wedding/india/modern_mobile.webp">
                        <source media="(max-width: 992px)" width="943" height="726" srcset="~/assets/landing/wedding/india/modern_mobile.jpg">  
                        <img class="radious_eight" loading="lazy" src="~/assets/landing/wedding/india/modern.jpg" width="885" height="885" alt="Wedding Creations For The Modern Bride">
                    </picture>
                    <picture v-else>
                        <source media="(min-width: 768px)" width="885" height="885" srcset="~/assets/landing/wedding/modern.webp">
                        <source media="(min-width: 768px)" width="885" height="885" srcset="~/assets/landing/wedding/modern.jpg">
                        <source media="(max-width: 992px)" width="943" height="726" srcset="~/assets/landing/wedding/modern_mobile.webp">
                        <source media="(max-width: 992px)" width="943" height="726" srcset="~/assets/landing/wedding/modern_mobile.jpg">  
                        <img class="radious_eight" loading="lazy" src="~/assets/landing/wedding/modern.jpg" width="885" height="885" alt="Wedding Creations For The Modern Bride">
                    </picture>
                </div>
            </div>
            
        </div>
        <div class="container_fluid container-fluid">
            <div class="row row_mod">
                <div class="px-0 text-left custom_block col-md-12 col-lg-6 col-12 radius_mod_left">
                    <picture>
                        <source width="895" height="400" srcset="~/assets/landing/wedding/we_design.webp">
                        <img alt="You Inspire, We Design!" loading="lazy" width="895" height="400" src="~/assets/landing/wedding/we_design.jpg">
                    </picture>
                </div>                
                <div class="justify-content-center align-items-center px-0 col-md-12 col-lg-6 col-12 radius_mod_right">
                    <div class="custom_text_box d-flex justify-content-center align-items-center">
                        <div class="custom_text">
                            <h3 class="font-active">
                                You Inspire, We Design!<br>
                            </h3>
                            <span>
                                <strong>{{ $t('customize') }} your {{ $t('jewelry') }} and ring designs.</strong>
                            </span>
                            <p v-if="$country.is_india">A bespoke experience to bring your wedding and bridal {{ $t('customize') }} designs to life.</p>
                            <p v-else>A bespoke experience to bring your wedding and bridal {{ $t('jewelry') }} designs to life.</p>
                            <NuxtLink class="anker radious_four" :to="localePath('/customized-jewelry')">
                                <span>{{ $t('customize') }} Wedding {{ $t('jewelry') }}</span>
                            </NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="container">
            <div class="customer_created">
               
            </div>
        </div> -->
        <LandingBestSeller :type="'band'" />
        <!-- <section class="shape_block">
            <div class="container">
            </div>
        </section> -->
        <HomeBlog :type="'band'" />
        <!-- <div class="container my-5">
        </div> -->
        <div class="container-md guide_faq">
            <FaqDynamicFaq  class="my-5" />
            
        </div>
        <div class="container-md" v-if="$country.trustpilot">
            <HomeTrustpilotReview />
        </div>
    </div>
</template>

<script setup>

    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );

    definePageMeta({
        keepalive:{
            // exclude: ['CommonTheHeader']
        },
    })

   


</script>


<style scoped>
.radius_mod_left {
    border-radius: 8px 0 0 8px;
    overflow: hidden;
}
.radius_mod_right {
    border-radius: 0 8px 8px 0;
    overflow: hidden;
}
section.banner_block{
    position: relative;
}
.container_fluid{
    padding: 2% 3%;
}
.banner_upper {
    position: absolute;
    top: 50%;
    left: 33%;
    transform: translate(-50%, -50%);
}
.banner_upper h1 {
    font-size: 48px;
    color: #000;
}
.banner_upper p {
    color: #000;
    font-size: 16px;
    padding: 4% 0;
}
a.anker {
    display: inline-block;
    font-size: 13px;
    color: #000;
    text-transform: uppercase;
    font-weight: 600;
    border: 1px solid #000;
    padding: 12px 25px;
}
a.anker_light{
    color: #fff;
    border: 1px solid #fff;
}
.extra_text{
    padding: 4% 0;
}
.extra_text p{
    color: #6a6161;
    font-size: 16px;
    text-align: center;
}
.modern_block p{
    font-size: 16px;
    color: #6a6161;
    padding: 5% 0;
}
.modern_block p a {
    text-decoration: underline;
}
.modern_block h2{
    font-size: 40px;
}
.custom_text_box{
    background: #f8f8f8;
    height: 100%;
}
.custom_block{
    background: #f8f8f8;
}
.custom_text h3 {
    font-size: 32px;
}
.custom_text span {
    text-transform: capitalize;
}
.custom_text {
    padding: 5%;
}
.custom_text p {
    font-size: 16px;
    padding: 2% 0;
}

.shape_block{
    background: #faf9f7;
    padding: 3% 0;
}
.customer_created {
    padding: 3% 0 4% 0;
}
.what_lab {
    padding: 4% 0;
}
@media(max-width: 1300px){
    .banner_upper h1{
        font-size: 32px;
    }
    .custom_text h3{
        font-size: 28px;
    }
}
@media (max-width: 1200px){
    .custom_text p{
        padding: 0;
    }
    .custom_text h3{
        font-size: 26px;
    }
    .custom_text {
        padding: 3%;
        /* text-align: center; */
    }
}
@media(max-width: 992px){
    .shape_block{
        padding: 3%;
    }
    .banner_upper {
        left: 25%;
    }
    .banner_upper h1{
        font-size: 26px;
    }
    .banner_upper h1 br{
        display: none;
    }
    .banner_upper p{
        font-size: 16px;
        padding-top: 2%;
    }
    .extra_text p{
        font-size: 16px;
    }
    .extra_text p br{
        display: none;
    }
    .modern_block h2 {
        font-size: 32px;
    }
    .modern_block p{
        padding: 3% 0;
    }
    .modern_block h2 br{
        display: none;
    }
    .custom_text h3{
        font-size: 24px;
    }
    .custom_text h3 br{
        display: none;
    }
    .custom_text p{
        padding: 0;
    }
    .custom_text p br{
        display: none;   
    }
    .custom_text {
        padding: 4%;
        /* text-align: center; */
    }
    .custom_text h3{
        font-size: 24px;
    }
    .custom_text h3 br{
        display: none;
    }
    .radius_mod_left {
        border-radius: 8px 8px 0 0;
    }
    .radius_mod_right {
        border-radius: 0 0 8px 8px;
    }
}
@media(max-width: 767px){
    .shape_block {
        padding: 5%;
    }
    .banner_upper {
        position: relative;
        top: 0;
        left: 0;
        transform: none;
        width: 100%;
        text-align: center;
        /* background: rgb(243 234 230); */
        padding: 6% 6% 8% 6%;
        margin-top: -5px;
    }
    .banner_upper h1{
        font-size: 32px;
    }
    .banner_upper p {
        font-size: 16px;
    }
    .extra_text p{
        font-size: 16px;
    }
    .extra_text {
        padding: 10% 5%;
    }
    .modern_block{
        text-align: center;
    }
    .modern_block h2 {
        font-size: 24px;
    }
    .modern_block h2 br{
        display: none;
    }
    .custom_text{
        text-align: center;
    }
    .custom_text {
        padding: 10% 5%;
        /* background: #f2e3da; */
    }
}
/* ---------------- */
.banner_upper {
    position: absolute;
    top: 50%;
    left: 75%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: max-content;
}
.banner_upper h1 {
    font-size: 70px;
    color: #b67913;
    text-transform: uppercase;
}
.banner_upper p {
    color: #000;
    font-size: 18px;
    padding: 2% 0 4% 0;
    text-transform: capitalize;
}
.banner_upper a {
    min-width: 270px;
    letter-spacing: 1px;
}
@media(max-width: 1300px){
    .banner_upper h1{
        font-size: 48px;
    }
    .banner_upper p{
        font-size: 16px;
    }
    .banner_upper a {
        min-width: 220px;
        padding: 9px;
    }
}
@media(max-width: 992px){
  
    .banner_upper h1{
        font-size: 26px;
    }
    .banner_upper h1 br{
        display: none;
    }
    .banner_upper p{
        font-size: 16px;
        padding: 4% 2% 8% 0;    
    }
}
@media(max-width: 767px){
    .banner_upper {
        width: 100%;
        top: 73%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .banner_upper h1{
        font-size: 30px;
    }
    .banner_upper p {
        font-size: 16px;
        padding: 4% 2% 6% 0;
    }
}

@media(max-width:500px) {
    .radius_mod_right {
        border-radius: 0;
    }
    .radius_mod_left {
        border-radius: 0;
    }
}
</style>